<template>
  <v-content>
    <v-flex xs12 md12>
      <v-alert :value="error" type="error">{{error}}.</v-alert>
    </v-flex>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Oturum aç</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="person"
                  v-model.trim="username"
                  label="Kullanıcı Adı"
                  type="text"
                  v-on:keyup.enter="login"
                ></v-text-field>
                <v-text-field
                  prepend-icon="lock"
                  v-model.trim="password"
                  label="Şifre"
                  v-on:keyup.enter="login"
                  type="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-on:keyup.enter="login" @click="login">Oturum Aç</v-btn>
            </v-card-actions>
            <v-progress-linear :indeterminate="loading"></v-progress-linear>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import { authenticationService } from "@/_services";

export default {
  props: {
    source: String
  },
  data() {
    return {
      username: "admin",
      password: "admin",
      submitted: false,
      loading: false,
      returnUrl: "",
      error: ""
    };
  },

  validations: {
    username: { required },
    password: { required }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "empty-layout");

    // redirect to home if already logged in
    if (authenticationService.currentUserValue) {
      return this.$router.push("/");
    }

    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    login() {
      this.submitted = true;

      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     return;
      // }

      this.loading = true;
      authenticationService.login(this.username, this.password).then(
        user => {
          if (user.isAdmin) {
            this.$store.commit("SET_LAYOUT", "admin-layout");
            this.$router.push("/admin");
          } else {
            this.$store.commit("SET_LAYOUT", "app-layout");
            window.location = this.returnUrl;
          }
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  }
};
</script>